function getAppID() {
  const pathnames = window.location.pathname.split('/')
  const appID = pathnames[1];
  if (appID === 'ERP' || appID === 'analytics') {
    return pathnames?.[2] || null
  }
  
  if (appID) {
    return appID;
  }
  return null;
}

// export function getAppIDFromURL() {
//   return window.location.href.split('/')[3];
// }

export default getAppID;

export const getDefaultAppID=(userData)=> {
  return userData?.appsConnected?.[0];
}

